<template>
  <div class="partner-page casas-bahia-page">
    <PartnersBanner :creditor="creditor" />
    <PartnersHowItWorks :creditor="creditor" />
    <HomeOurChannels
      iconsPath="partners/"
      mobilePath="/images/partners/casas-bahia/m-our-channel.png"
      desktopPath="/images/partners/casas-bahia/our-channel.png"
      :isPartner="true"
    />
    <PartnersLoggedArea :imageFolder="'partners/' + creditor.alias" />
    <PartnersNeedHelp :creditor="creditor" />
    <HomeOurPartners :partnerName="creditor.name" :isPartner="true" />
  </div>
</template>

<script setup lang="ts">
definePageMeta({
  layout: "creditor",
});

const creditor = ref<CreditorProfile>({
  name: "Casas Bahia",
  alias: "casas-bahia",
  id: 3,
  chave: "casas_bahia",
});
</script>

<style lang="scss">
@use "@/styles/variables" as v;
@use "@/styles/partners/casasBahia" as cb;

.casas-bahia-header {
  .content .creditor-logo {
    max-width: 161px;
    max-height: 17.121px;
    width: 100%;
    height: 100%;
    margin-right: 17px;

    @media screen and (min-width: 834px) and (max-width: 959px) {
      max-width: 163.2px;
      max-height: 17.3px;
      margin-right: 28px;
    }

    @media screen and (min-width: 960px) {
      max-width: 170px;
      max-height: 18px;
      margin-right: 30px;
    }
  }
}

.casas-bahia-page {
  .text-chip {
    background-color: cb.$primaryColor !important;
    color: v.$white !important;
  }

  .title {
    color: v.$greyDark !important;
    font-family: "Open Sans";
    font-weight: 800;
  }

  .partner-banner-section {
    background-image: url(@/assets/images/partners/casas-bahia/bg-banner.png);
    background-position: 45% top;
    border-bottom: 10px solid cb.$secondaryColor;

    .wrapper {
      .banner-content {
        .banner-text {
          max-width: 300px;
        }

        .banner-button {
          background-color: cb.$secondaryColor;
          margin: 0px auto 13px;

          &:hover {
            background-color: cb.$buttonHover;
          }
        }
      }

      .image-component img {
        margin-bottom: -10px;
      }

      @media screen and (min-width: 834px) and (max-width: 1199px) {
        .banner-content {
          .banner-text {
            width: 330px;
          }
          .banner-button {
            margin: 0px 0px 69px;
          }
        }
      }

      @media screen and (min-width: 960px) and (max-width: 1199px) {
        padding: 0px 32.5px;

        .image-component img {
          width: 522px;
        }
      }

      @media screen and (min-width: 834px) {
        .banner-content {
          .banner-text {
            max-width: unset;
          }
        }
      }

      @media screen and (min-width: 1200px) {
        .banner-content {
          .banner-text {
            width: 438px;
            margin: 29px 0px 30px;
          }

          .banner-button {
            margin: 0px 0px 132px;
          }
        }
      }
    }
  }

  .partner-how-works-section {
    .steps {
      .default-card .step-counter {
        background-color: cb.$tertiaryColor;
      }
    }
  }

  .our-channels-section.partner-page {
    @media screen and (min-width: 1200px) {
      padding: 68px 0px 65px;
    }
  }

  .partner-logged-area {
    @media screen and (min-width: 1200px) {
      .content-box {
        column-gap: 80px;
      }
    }
  }

  .need-help-section {
    .the-faq-list {
      .panels {
        .panel {
          .v-expansion-panel-title {
            &:hover {
              color: cb.$primaryColor;
            }

            .mdi {
              color: cb.$primaryColor;
            }
          }

          .v-expansion-panel-title--active {
            color: cb.$primaryColor;
          }

          &:hover {
            border-color: cb.$primaryColor;
          }
        }

        .v-expansion-panel--active {
          border-color: cb.$primaryColor !important;
        }
      }
    }

    .talk-button {
      background-color: cb.$secondaryColor;
      color: v.$white;

      &:hover {
        background-color: cb.$buttonHover !important;
      }
    }
  }

  .our-partners-section.partner-page {
    .content .content-sheet .creditors .creditor-block .creditor-logo:hover {
      border-color: cb.$primaryColor;
      box-shadow: 0px 6px 15px cb.$dropShadow !important;
    }
  }
}
</style>
